import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "badge-list" }

import BadgeListItem from '../atoms/BadgeListItem.vue'
type BadgeItemProps = {
  text: string
  color?: string
  children?: BadgeItemProps[]
}
type BadgeListProps = {
  items: BadgeItemProps[]
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BadgeList',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createBlock(BadgeListItem, {
        key: item.text,
        text: item.text,
        color: item.color,
        children: item.children
      }, null, 8, ["text", "color", "children"]))
    }), 128))
  ]))
}
}

})